import { Formik } from "formik";
import * as Yup from "yup";
import Modal from "../../designComponents/Modal";
import { AcceptButton, LabelText } from "../Properties/Details/styles";
import { Input, InputGroup } from "./styles";

type ValuesType = {
  vatPercentage: number;
};

const validationSchema = Yup.object().shape({
  vatPercentage: Yup.number()
    .typeError("Must be a number")
    .required("Number is required")
    .min(1, "Number cannot be less than 1")
    .max(100, "Number cannot be more than 100"),
});

function AddEditVatPercentageTrade({
  isOpen,
  onClose,
  initialValues,
  handleSubmit,
  type = "Add",
}: {
  isOpen: boolean;
  onClose: () => void;
  initialValues: ValuesType;
  handleSubmit: (values: ValuesType) => void;
  type?: "Add" | "Edit";
}) {
  return (
    <Modal
      isOpen={isOpen}
      halfWidth={true}
      onClose={onClose}
      title={`${type} Vat Percentage`}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => handleSubmit(values)}
        validationSchema={validationSchema}
      >
        {({
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
          handleBlur,
        }) => {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    overflowY: "auto",
                    maxHeight: 400,
                  }}
                >
                  <InputGroup>
                    <LabelText>Vat Percentage For Trade</LabelText>
                    <Input
                      type="number"
                      step="0.01" // allows decimal input
                      value={values.vatPercentage}
                      onChange={(e) => {
                        const val = e.target.value;
                        setFieldValue(
                          "vatPercentage",
                          val === "" ? "" : parseFloat(val),
                        );
                      }}
                      onBlur={handleBlur("vatPercentage")}
                      placeholder="Enter Vat Percentage for Trade"
                    />
                    {touched.vatPercentage && errors.vatPercentage && (
                      <div style={{ color: "red", marginTop: 4 }}>
                        {errors.vatPercentage}
                      </div>
                    )}
                  </InputGroup>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  paddingTop: 20,
                }}
              >
                <AcceptButton onClick={() => handleSubmit()}>Save</AcceptButton>
              </div>
            </>
          );
        }}
      </Formik>
    </Modal>
  );
}

export default AddEditVatPercentageTrade;
